import { render, staticRenderFns } from "./tian_hz.vue?vue&type=template&id=706f6ff1&scoped=true&"
import script from "./tian_hz.vue?vue&type=script&lang=js&"
export * from "./tian_hz.vue?vue&type=script&lang=js&"
import style0 from "./tian_hz.vue?vue&type=style&index=0&id=706f6ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f6ff1",
  null
  
)

export default component.exports